const configuration = {
  // dev: {
  //     host: "https://mitservice-dev.app.dev.dal.pcf.syfbank.com",
  //     host1: "https://mppcore-dev.app.dev.dal.pcf.syfbank.com",
  //     dbuyTip: "https://detail.mysynchrony.com/dbuyTIP/",
  //     dbuyQa: "https://qbuy.syf.com"
  // },
  dev: {
    host: "https://dpdpone.syfpayments.com/mitservice",
    host1: "https://dpdpone.syfpayments.com/mppcore",
    dbuyTip: "https://pos.dbusinesscenter.synchronybusiness.com/dbuyTIP/",
    dbuyQa: "http://pos.dbuy.syf.com",
    applyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
    preqApplyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
    syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
    mppCheckout:
      "https://dpdpone.syfpayments.com/mppcore/mppCheckOutNew",
    msfCheckout: "https://dpdpone.syfpayments.com/mppcore/msfCheckout",
    widgeturl: "https://dwidgets.syfpayments.com",
    payLaterUrl:"https://iwww.setpay.com/datashare",
    payLaterLookUpUrl:"https://uwww.setpay.com/lookup/datashare",

  },
   dev2: {
    host: "https://d2pdpone.syfpayments.com/mitservice",
    host1: "https://d2pdpone.syfpayments.com/mppcore",
    dbuyTip: "https://pos.dbusinesscenter.synchronybusiness.com/dbuyTIP/",
    dbuyQa: "https://pos.dbuy.syf.com",
    applyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
    preqApplyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
    syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
    msfCheckout: "https://d2pdpone.syfpayments.com/mppcore/msfCheckout",
    mppCheckout:
      "https://d2pdpone.syfpayments.com/mppcore/mppcheckout",
    widgeturl: "https://dwidgets.syfpayments.com",
    payLaterUrl:"https://qwww.setpay.com/datashare",
    payLaterLookUpUrl:"https://qwww.setpay.com/lookup/datashare",

  },
  dev1: {
    host: "https://mitservice-dev.app.dev1.dal.pcf.syfbank.com/mitservice",
    host1: "https://mppcore-dev.app.dev1.dal.pcf.syfbank.com/mppcore",
    dbuyTip: "https://pos.dbusinesscenter.synchronybusiness.com/dbuyTIP/",
    dbuyQa: "https://pos.dbuy.syf.com",
    applyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
    preqApplyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
    syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
    msfCheckout: "https://mppcore-dev.app.dev1.dal.pcf.syfbank.com/mppcore/msfCheckout",
    mppCheckout:
      "https://mppcore-dev.app.dev1.dal.pcf.syfbank.com/mppcore/mppcheckout",
    widgeturl: "https://widget-domain-service-dev.app.dev.usw2.pcf.syfbank.com",
    payLaterUrl:"https://qwww.setpay.com/datashare",
    payLaterLookUpUrl:"https://qwww.setpay.com/lookup/datashare",
  },
  phx: {
    host: "https://mitservice-dev.app.phx.phx.pcf.syfbank.com/mitservice",
    host1: "https://mppcore-dev.app.dev.phx.pcf.syfbank.com/mppcore",
    dbuyTip: "https://pos.dbusinesscenter.synchronybusiness.com/dbuyTIP/",
    dbuyQa: "https://pos.dbuy.syf.com",
    applyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
    preqApplyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
    syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
    msfCheckout: "https://mppcore-dev.app.dev.phx.pcf.syfbank.com/mppcore/msfCheckout",
    mppCheckout:
      "https://mppcore-dev.app.dev.phx.pcf.syfbank.com/mppcore/mppcheckout",
    widgeturl: "https://dwidgets.syfpos.com",
    payLaterUrl:"https://qwww.setpay.com/datashare",
    payLaterLookUpUrl:"https://qwww.setpay.com/lookup/datashare",
  },
  local: {
    widgeturl: "https://dwidgets.syfpayments.com",
    host: "http://localhost:8080",
    host1: "http://localhost:8090/mppcore",
    dbuyTip: "https://detail.mysynchrony.com/dbuyTIP/",
    dbuyQa: "https://qbuy.syf.com",
    applyHost: "https://detail.mysynchrony.com/eapply/eapply.action",
    preqApplyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
    syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
    mppCheckout: "http://localhost:8090/mppcore/mppcheckout",
    msfCheckout: "http://localhost:8090/mppcore/msfCheckout",
    payLaterUrl:"https://qwww.setpay.com/datashare",
    payLaterLookUpUrl:"https://qwww.setpay.com/lookup/datashare",
  },
  qa: {
    host: "https://qpdpone.syfpayments.com/mitservice",
    host1: "https://qpdpone.syfpayments.com/mppcore",
    dbuyTip: "https://pos.qbusinesscenter.synchronybusiness.com/dbuyTIP/",
    dbuyQa: "https://pos.qbuy.syf.com",
    applyHost: "https://pos.qapply.syf.com/eapply/eapply.action",
    preqApplyHost: "https://pos.qapply.syf.com/eapply/eapply.action",
    syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
    mppCheckout: "https://qpdpone.syfpayments.com/mppcore/mppcheckout",
    msfCheckout: "https://qpdpone.syfpayments.com/mppcore/msfCheckout",
    widgeturl: "https://qwidgets.syfpayments.com",
    payLaterUrl:"https://uwww.setpay.com/datashare",
    payLaterLookUpUrl:"https://uwww.setpay.com/lookup/datashare",
  },
  uat: {
    host: "https://updpone.syfpayments.com/mitservice",
    host1: "https://updpone.syfpayments.com/mppcore",
    dbuyTip: "https://pos.ubusinesscenter.synchronybusiness.com/dbuyTIP/",
    dbuyQa: "https://pos.ubuy.syf.com",
    applyHost: "https://pos.uapply.syf.com/eapply/eapply.action",
    preqApplyHost: "https://pos.uapply.syf.com/eapply/eapply.action",
    syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
    mppCheckout: "https://updpone.syfpayments.com/mppcore/mppcheckout",
    msfCheckout: "https://updpone.syfpayments.com/mppcore/msfCheckout",
    widgeturl: "https://uwidgets.syfpayments.com",
    payLaterUrl:"https://uwww.setpay.com/datashare",
    payLaterLookUpUrl:"https://uwww.setpay.com/lookup/datashare",
  },
  stg: {
    host: "https://spdpone.syfpayments.com/mitservice",
    host1: "https://spdpone.syfpayments.com/mppcore",
    dbuyTip: "https://pos.sbusinesscenter.synchronybusiness.com/dbuyTIP/",
    dbuyQa: "https://pos.sbuy.syf.com",
    applyHost: "https://pos.sapply.syf.com/eapply/eapply.action",
    preqApplyHost: "https://pos.sapply.syf.com/eapply/eapply.action",
    syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
    mppCheckout: "https://spdpone.syfpayments.com/mppcore/mppcheckout",
    msfCheckout: "https://spdpone.syfpayments.com/mppcore/msfCheckout",
    widgeturl: "https://swidgets.syfpayments.com",
    payLaterUrl:"https://swww.setpay.com/datashare",
    payLaterLookUpUrl:"https://swww.setpay.com/lookup/datashare",
  },
  prf: {
    host: "https://ppdpone.syfpayments.com/mitservice",
    host1: "https://ppdpone.syfpayments.com/mppcore",
    dbuyTip: "https://pos.pbusinesscenter.synchronybusiness.com/dbuyTIP/",
    dbuyQa: "https://pos.pbuy.syf.com",
    applyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
    preqApplyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
    syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
    mppCheckout: "https://ppdpone.syfpayments.com/mppcore/mppcheckout",
    msfCheckout: "https://ppdpone.syfpayments.com/mppcore/msfCheckout",
    widgeturl: "https://pwidgets.syfpayments.com",
    payLaterUrl:"https://uwww.setpay.com/datashare",
    payLaterLookUpUrl:"https://uwww.setpay.com/lookup/datashare",
  },
  prod: {
    host: "https://pdpone.syfpayments.com/mitservice",
    host1: "https://pdpone.syfpayments.com/mppcore",
    dbuyQa: "https://buy.syf.com",
    applyHost: "https://etail.mysynchrony.com/eapply/eapply.action",
    preqApplyHost: "https://etail.mysynchrony.com/eapply/eapply.action",
    syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
    mppCheckout: "https://pdpone.syfpayments.com/mppcore/mppcheckout",
    msfCheckout: "https://pdpone.syfpayments.com/mppcore/msfCheckout",
    widgeturl: "https://widgets.syfpayments.com",
    payLaterUrl:"https://www.setpay.com/datashare",
    payLaterLookUpUrl:"https://www.setpay.com/lookup/datashare",
  },


  use1: {
    //for temp purpose using dev env urls for use1
   host: "https://dpdpone.syfpayments.com/mitservice",
     host1: "https://dpdpone.syfpayments.com/mppcore",
     dbuyTip: "https://pos.dbusinesscenter.synchronybusiness.com/dbuyTIP/",
     dbuyQa: "https://pos.dbuy.syf.com",
     applyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
     preqApplyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
     syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
     msfCheckout: "https://dpdpone.syfpayments.com/mppcore/msfCheckout",
     mppCheckout:
       "https://dpdpone.syfpayments.com/mppcore/mppcheckout",
     widgeturl: "https://dwidgets.syfpayments.com",
     payLaterUrl:"https://qwww.setpay.com/datashare",
     payLaterLookUpUrl:"https://qwww.setpay.com/lookup/datashare",
       
  },
  use2: {
   host: "https://dpdpone.syfpayments.com/mitservice",
     host1: "https://dpdpone.syfpayments.com/mppcore",
     dbuyTip: "https://pos.dbusinesscenter.synchronybusiness.com/dbuyTIP/",
     dbuyQa: "https://pos.dbuy.syf.com",
     applyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
     preqApplyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
     syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
     msfCheckout: "https://dpdpone.syfpayments.com/mppcore/msfCheckout",
     mppCheckout:
       "https://dpdpone.syfpayments.com/mppcore/mppcheckout",
     widgeturl: "https://dwidgets.syfpayments.com",
     payLaterUrl:"https://qwww.setpay.com/datashare",
     payLaterLookUpUrl:"https://qwww.setpay.com/lookup/datashare",
       
  },
usw2: {
    //for temp purpose using dev env urls for usw2
     widgeturl: "https://dwidgets.syfpayments.com",
     host: "https://dpdpone.syfpayments.com/mitservice",
       host1: "https://dpdpone.syfpayments.com/mppcore",
       dbuyTip: "https://pos.dbusinesscenter.synchronybusiness.com/dbuyTIP/",
       dbuyQa: "https://pos.dbuy.syf.com",
       applyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
       preqApplyHost: "https://pos.dapply.syf.com/eapply/eapply.action",
       syfLoadingImageURL: "/digitalbuy/images/ajax-loader.gif",
       msfCheckout: "https://dpdpone.syfpayments.com/mppcore/msfCheckout",
       mppCheckout:
         "https://dpdpone.syfpayments.com/mppcore/mppcheckout",
       payLaterUrl:"https://qwww.setpay.com/datashare",
       payLaterLookUpUrl:"https://qwww.setpay.com/lookup/datashare",
 },

};
export default configuration;
